/**
 * @param {{
 *   AnalyticsService: ReturnType<import('../../services/AnalyticsService').default>,
 * }} param0
 */
export default function dashboardAnalyticsUseCase({ DashboardAnalyticsService }) {
  const getDashboardAnalytics = (params) => {
    return DashboardAnalyticsService.getDashboardAnalytics(params);
  };

  return {
    getDashboardAnalytics: getDashboardAnalytics,
  };
}
